export default __webpack_public_path__ + "static/media/baseline-calendar.88f607fc.svg";